export function createFindInFileWorker() {
  return new Worker(new URL('./find-in-file.worker.ts', import.meta.url), {type: 'module'})
}
